import { z } from 'zod';
import type { GetUserDto } from '../types/GetUserDto';

export const getUserDtoSchema = z.union([
  z.object({
    id: z.string().uuid(),
    auth0Id: z.string(),
    firstName: z.string().min(2).max(64),
    lastName: z.string().min(2).max(64),
    email: z.string().email(),
    backupEmail: z.string().email().nullable(),
    phoneNumber: z.string().nullable(),
    username: z.string().nullable(),
    avatar: z.string().nullable(),
    description: z.string().min(3).max(255).nullable(),
    timeZone: z.string().nullable(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
    role: z.enum(['admin']),
  }),
  z.object({
    id: z.string().uuid(),
    auth0Id: z.string(),
    firstName: z.string().min(2).max(64),
    lastName: z.string().min(2).max(64),
    email: z.string().email(),
    backupEmail: z.string().email().nullable(),
    phoneNumber: z.string().nullable(),
    username: z.string().nullable(),
    avatar: z.string().nullable(),
    description: z.string().min(3).max(255).nullable(),
    timeZone: z.string().nullable(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
    role: z.enum(['teacher']),
    speciality: z.string().nullable(),
    language: z
      .enum(['eng', 'fra', 'spa', 'deu', 'ita', 'ukr'])
      .default('eng')
      .optional()
      .nullable(),
  }),
]) as z.ZodType<GetUserDto>;
